import React, { useState, useContext, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import './Procedimientos.css';

import Swal from 'sweetalert2'

import ProcedimientoForm from "../../components/formProcedimiento/ProcedimientoForm.js";
import ProcedimientosList from "../../components/procedimientoList/ProcedimientosList.js";

import procedimientoContext from "../../context/procedimientoContext/procedimientoContext.js";

import { estructuraProcedimientoForm } from "../../utils/estructuras.js";

const Procedimientos = () =>{

    const [showABM,setShowABM] = useState(true); //Indica si se visualiza ABM o se renderiza el formulario de Procedimiento
    const [procToModify,setProcToModify] = useState({});
    const [title,setTitle] = useState('Nuevo Procedimiento') //Encargado de setear titulo en base a si edita o agrega procedimiento.

    const pContext = useContext(procedimientoContext);
    const {procedimientoList, actualizarProcedimientoList, agregarProcedimiento, eliminarProcedimiento, getProcedimientoByID} = pContext;
    
    const location = useLocation();
    const {activo,index} = location.state || {}

    useEffect(()=>{
        actualizarProcedimientoList();
    },[])

    useEffect(()=>{
        if(activo != undefined && index != undefined){
            let procToHandle = {...estructuraProcedimientoForm, codProc:`CORRECTIVO-${activo.codActivo}`, name:`Correctivo sobre activo ${activo.name}`,fromActivo:true, tipProc:{label:'Correctivo',value:'CORRECTIVO'},tipAct:[{label:activo.nameTypeActivo,value:activo.codTipoActivo}]}
            setProcToModify(procToHandle);
            setShowABM(false);
        }
    },[activo,index])

    return <div className="procedimientosAbmPage">
       {showABM ? <ProcedimientosList procedimientos={procedimientoList} setProcToModify={setProcToModify} setShowABM={setShowABM} setTitle={setTitle} eliminarProcedimiento={eliminarProcedimiento} actualizarProcedimientoList={actualizarProcedimientoList} getProcedimientoByID={getProcedimientoByID}/> : <ProcedimientoForm procToModify={procToModify} setShowABM={setShowABM} setProcToModify={setProcToModify}/>}
    </div>

}

export default Procedimientos;